import AutoTextarea from './AutoTextarea';
import FieldNumber from './FieldNumber';

const TextField = (props) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    props.setData((prev) =>
      prev.map((item) =>
        item.Id === props.id
          ? { ...item, [props.field]: newValue }
          : item
      )
    );
  };

  if (props.type == "number") {
    return (
      <FieldNumber 
        value={props.value}
        isEditor={props.isEditor}
        onChange={handleChange}
        className={props.className}
      />
    );
  }

  return (
    <AutoTextarea
      value={props.value}
      isEditor={props.isEditor}
      rows={1}
      onChange={handleChange}
      textClassName={props.className}
    />
  );
};

export default TextField;
